/* Keep the shopper's disclosure choice when Dawn replaces cart sections. */
if (!customElements.get('potion-cart-offer')) {
  customElements.define('potion-cart-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.onToggle) return;
      this.details = this.querySelector('details');
      if (!this.details) return;
      try { this.details.open = sessionStorage.getItem('potion.cartRecommendationHidden') !== 'true'; } catch (_) {}
      this.onToggle = () => { try { sessionStorage.setItem('potion.cartRecommendationHidden', String(!this.details.open)); } catch (_) {} };
      this.onChange = (event) => {
        const variant = event.target.closest('[data-offer-variant]');
        if (!variant) return;
        event.stopPropagation();
        const card = variant.closest('[data-offer-card]');
        const button = card.querySelector('[data-offer-add]');
        if (button) button.disabled = Boolean(this.busy) || !variant.value;
        const price = variant.selectedOptions?.[0]?.dataset.formattedPrice;
        if (price) card.querySelector('[data-offer-price]').textContent = price;
      };
      this.onClick = (event) => {
        const button = event.target.closest('[data-offer-add]');
        if (button && this.contains(button)) { this.addToBag(button); return; }
        const link = event.target.closest('.potion-cart-offer__card a');
        if (link && this.contains(link)) this.track('wzd_cart_upsell_clicked', link.closest('[data-offer-card]'), { action: 'product_link' });
      };
      this.onConsent = () => { clearTimeout(this.viewTimer); this.viewObserver?.disconnect(); this.viewObserver = null; this.viewAttempts = 0; this.startViewTracking(); };
      this.viewAttempts = 0;
      this.seenViews = new Set();
      this.startViewTracking();
      document.addEventListener('visitorConsentCollected', this.onConsent);
      document.addEventListener('wzd:analytics-consent', this.onConsent);
      this.details.addEventListener('toggle', this.onToggle);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
    }
    tracker() {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        const sdk = window.WZDPostHog?.wzd_recordings;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed() || !sdk || typeof sdk.capture !== 'function' || sdk.has_opted_out_capturing?.()) return null;
        return sdk;
      } catch (_) { return null; }
    }
    track(name, card, extra = {}) {
      try {
        const sdk = this.tracker();
        const handle = card?.dataset.productHandle;
        const id = card?.dataset.productId;
        const position = Number(card?.dataset.position);
        if (!sdk || !/^[a-z0-9_-]+$/.test(handle || '') || !/^\d+$/.test(id || '') || !Number.isInteger(position) || position < 1 || position > 3) return false;
        sdk.capture(name, { product_handle: handle, product_id: id, position, theme_role: window.Shopify?.theme?.role === 'main' ? 'live' : 'preview_or_unknown', ...extra });
        return true;
      } catch (_) { return false; }
    }
    startViewTracking() {
      if (this.viewObserver || !this.isConnected) return;
      if (!this.tracker()) {
        if (this.viewAttempts++ < 20) this.viewTimer = setTimeout(() => this.startViewTracking(), 500);
        return;
      }
      if (typeof IntersectionObserver !== 'function') return;
      this.viewObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || !this.details.open || this.seenViews.has(entry.target)) return;
          if (this.track('wzd_cart_upsell_viewed', entry.target)) { this.seenViews.add(entry.target); this.viewObserver.unobserve(entry.target); }
        });
      }, { threshold: 0.5 });
      this.querySelectorAll('[data-offer-card]').forEach(card => this.viewObserver.observe(card));
    }
    async addToBag(button) {
      const card = button.closest('[data-offer-card]');
      const variant = card.querySelector('[data-offer-variant]');
      const status = card.querySelector('.potion-cart-offer__status');
      if (this.busy || button.disabled || !variant?.value) return;
      this.track('wzd_cart_upsell_clicked', card, { action: 'add_to_bag', variant_id: String(variant.value) });
      this.busy = true;
      this.querySelectorAll('[data-offer-add]').forEach(item => { item.disabled = true; });
      button.textContent = 'Adding…';
      status.textContent = '';
      let added = false;
      try {
        const drawer = this.closest('cart-drawer');
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variant.value, quantity: 1 }], sections: drawer.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add this item. Please try again.');
        added = true;
        this.track('wzd_cart_upsell_added', card, { variant_id: String(variant.value) });
        if (!result.sections) throw new Error('Cart refresh unavailable');
        drawer.renderContents(result);
        const liveRegion = drawer.querySelector('#CartDrawer-LiveRegionText');
        if (liveRegion) liveRegion.textContent = 'Recommendation added to your bag.';
      } catch (error) {
        if (added) { window.location.assign(this.dataset.cartUrl); return; }
        status.textContent = error instanceof TypeError ? 'Could not connect. Check your bag before trying again.' : error.message;
      } finally {
        if (!added) {
          this.busy = false;
          button.textContent = 'Add to bag';
          this.querySelectorAll('[data-offer-card]').forEach(item => {
            const choice = item.querySelector('[data-offer-variant]');
            const add = item.querySelector('[data-offer-add]');
            if (add) add.disabled = !choice?.value;
          });
        }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.viewTimer);
      this.viewObserver?.disconnect();
      this.viewObserver = null;
      document.removeEventListener('visitorConsentCollected', this.onConsent);
      document.removeEventListener('wzd:analytics-consent', this.onConsent);
      this.details?.removeEventListener('toggle', this.onToggle);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.onToggle = null;
    }
  });
}
